import { render, staticRenderFns } from "./BoxCarousel.vue?vue&type=template&id=20bc9f04&scoped=true"
import script from "./BoxCarousel.vue?vue&type=script&lang=js"
export * from "./BoxCarousel.vue?vue&type=script&lang=js"
import style0 from "./BoxCarousel.vue?vue&type=style&index=0&id=20bc9f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bc9f04",
  null
  
)

export default component.exports